import React from "react";
import PropTypes from "prop-types";

import analytics from "src/shared/contact-boxes/experts/utilities/analytics";
import useFeatureState from "src/shared/contact-boxes/experts/utilities/hooks/useFeatureState";
import useReducerActions from "src/shared/contact-boxes/experts/utilities/useReducerActions";

import { RESTRICTED_SALE } from "../../constants/saleTypes";
import { LandLeaseModal, RestrictedSaleModal } from "../WhatYouShouldKnowModal";
import * as S from "./styled";

const WhatYouShouldKnow = ({ listing }) => {
  const { dispatchSetWhatYouShouldKnowModal } = useReducerActions();
  const { expertsApiUuid } = useFeatureState();
  let description;
  let Modal;

  if (listing.is_land_lease) {
    description = "This building is on leased, not owned, land. ";
    Modal = LandLeaseModal;
  } else if (listing.sale_type === RESTRICTED_SALE) {
    description = "This is a restricted sale. Buyer income limits apply. ";
    Modal = RestrictedSaleModal;
  } else {
    return null;
  }

  return (
    <S.Info data-qa="restriction-info">
      <S.Icon />
      <S.Body>
        {description}
        <S.TextLinkButton
          onClick={event => {
            event.preventDefault();
            analytics({
              action: "click_to_restricted_sales_info",
              isHdp: true,
              label: `uuid=${expertsApiUuid}`
            });
            dispatchSetWhatYouShouldKnowModal({
              contactFormType: null,
              isModalOpen: true
            });
          }}
        >
          See what you should know
        </S.TextLinkButton>
        .
      </S.Body>
      <Modal />
    </S.Info>
  );
};

WhatYouShouldKnow.propTypes = {
  listing: PropTypes.shape({
    is_land_lease: PropTypes.bool,
    sale_type: PropTypes.string
  }).isRequired
};

export default WhatYouShouldKnow;
